import Mutations from '../../odata/mutations';

export default { ...new Mutations('restaurantAdmin'), ...new Mutations('restaurantAdmins') };
